/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

export function NoResultsWrapper( { children, shouldShowResults }: { children: ReactNode; shouldShowResults: boolean } ): ReactNode {
	if ( shouldShowResults ) {
		return children;
	}

	return (
		<Typography fontSize="12px">
			No results found.
		</Typography>
	);
}
